/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import VueSweetalert2 from 'vue-sweetalert2';
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import VModal from "vue-js-modal";
import VueHtml2pdf from 'vue-html2pdf';

// import 'vue-js-modal/dist/styles.css'
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.use(VueSweetalert2);
Vue.use(VModal);
Vue.use(VueHtml2pdf)


Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('search-component', require('./components/SearchComponent.vue').default);
Vue.component('setting-component', require('./components/SettingComponent.vue').default);
Vue.component('history-component', require('./components/HistoryComponent.vue').default);
Vue.component('log-component', require('./components/LogComponent.vue').default);
Vue.component('middleware-log-component', require('./components/MiddlewareLogComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
